import React from 'react'
import { QuestionFrame, YesNoQuestion, RadioQuestion } from 'components/questions'
import { useGlobalState } from 'state'


export const Q15 = () => {
  const state = useGlobalState()

  return (
    <QuestionFrame q={15}>

      <YesNoQuestion num={1} content={'水害訓練の手順は、防災マニュアルやタイムラインを元に実施していますか。'} />

      <RadioQuestion num={2} content={'水害訓練の体制は、防災マニュアル、BCPやタイムラインに記載された体制で実施していますか。'} row items={state.scoring.getRadioItems('q15-2')} />
      <YesNoQuestion num={3} content={'ハザードマップをテナントへ周知（配布又は掲示）していますか。'} />
      <YesNoQuestion num={4} content={'避難場所をテナントへ周知（配布又は掲示）していますか。'} />

    </QuestionFrame>
  )
}
